import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Icon, TextField, Select, SelectChangeEvent, InputLabel, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormControl, Container } from "@mui/material";
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import {  toast } from 'react-toastify';
import '../../assets/style/style.css';
import { useMaterialUIController, setOrderContext } from "context";
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Config from "../../config.js";
import Backdrop from '@mui/material/Backdrop';
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import productNoImage from "../../assets/images/no-image.png";
import { handleErrors } from "common.js";
import AddressDetails from './AddressDetails';
import FulfillmentAction from "./FulfillmentAction.js";
import FulfillmentList from "./FulfillmentList.js";
import UnfulfillmentList from "./UnfulfillmentList.js";
import OrderSummary from "./OrderSummary.js";
import CalculationDetails from "./CalculationDetails.js";
function OrderDetails() {
  const [controller, dispatch]                          = useMaterialUIController();
  const { orderContext }                                = controller;  
  const { orderID }                                     = useParams();  
  const navigate                                        = useNavigate();
  const { t }                                           = useTranslation();
  const baseUrl                                         = Config.baseUrl;
  const bearerToken                                     = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [loading, setLoading]                           = useState(false);
  const [isLoading, setIsLoading]                       = useState(false);
  const [isOrderRejectLoading, setIsOrderRejectLoading] = useState(false);
  const [pageContent, setPageContent]                   = useState({});
  const [orderRejectModelOpen, setOrderRejectModelOpen] = useState(false);
  const [openFulfillmentModel, setOpenFulfillmentModel] = useState(orderContext.fulfillmentModelOpen);
  const [orderRejectNote, setOrderRejectNote]           = useState("");
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [orderRejectReason, setOrderRejectReason] = useState("");

  useEffect(() => {
    loadOrderDetails();
  }, []);
  
  useEffect(() => {
    setOpenFulfillmentModel(orderContext.fulfillmentModelOpen);
  }, [orderContext.fulfillmentModelOpen]);
   
  const handleConfirmationDialogOpen = () => {    
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationDialogClose = () => {
    setConfirmationDialogOpen(false);
  };


  const handleOrderRejectModelClose = () => {
    setOrderRejectModelOpen(false);
    setIsOrderRejectLoading(false);
    setOrderRejectNote("");
  };

  const handleOrderRejectSubmit = () => {  
    setOrderRejectModelOpen(true);
  }  
  
  const handleChangeOrderRejectNote = (event) => {
    setOrderRejectNote(event.target.value);   
  };

  const handleChangeOrderRejectReason = (event: SelectChangeEvent) => {
    setOrderRejectReason(event.target.value);
  }; 

  const renderOrderRejectReason = (
    <>
      <InputLabel>{t('Order Reject Reason')}</InputLabel>
      <Select
          id="order-reject-reason"
          value={orderRejectReason}
          label={t('Order Reject Reason')}
          onChange={handleChangeOrderRejectReason}
          style={{ height: 45, zIndex: 1}}
        >      
        <MenuItem value='Item out of stock'>{t('Item out of stock')}</MenuItem>
        <MenuItem value='Item discontinued'>{t('Item discontinued')}</MenuItem>
        <MenuItem value='Shipping Issues'>{t('Shipping Issues')}</MenuItem>
        <MenuItem value='Others'>{t('Others')}</MenuItem>
      </Select>      
    </>
  );

  const handleOrderDetailsAPIResponse = (responseData, operation) => {

      if(operation === "details")
      setPageContent(responseData.data);      

      const unfulfilledColumns  =  [
        { label: `${t("Product ID")}`, field: "productId" },
        { label: `${t("Image")}`, field: "image" },
        { label: `${t("Product Name")}`, field: "title" },
        { label: `${t("Unit Price")}`, field: "price" },
        { label: `${t("Sku")}`,field: "sku" },
        { label: `${t("Qty")}`, field: "quantity" },
        { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
        { label: `${t("Avl. Qty For Fulfill")}`, field: "quantityForFulfill" },
        { label: `${t("Total")}`, field: "total" },
      ];

      const fulfilledColumns  =  [
        { label: `${t("Product ID")}`, field: "productId" },
        { label: `${t("Image")}`, field: "image" },
        { label: `${t("Product Name")}`, field: "title" },
        { label: `${t("Unit Price")}`, field: "price" },
        { label: `${t("Sku")}`,field: "sku" },
        { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
        { label: `${t("Shipment Status")}`, field: "shipmentStatus" },
      ];

      var unfulfilledRows          = [];
      var unfulfilledProductsCount = 0; 
      var allItemsFulfilled        = true;

      responseData.data.orderItemList.map((item, index) => {

          let productImage             = item.productImage ? item.productImage : productNoImage;
              unfulfilledProductsCount = (item.fulfillmentStatus === 'unfulfilled') ? unfulfilledProductsCount+1 : unfulfilledProductsCount;
              
              if(allItemsFulfilled)
              allItemsFulfilled = (item.fulfillmentStatus === 'unfulfilled' || item.fulfillmentStatus === 'partially_fulfilled') ? false : true;

          var tempData = {
            "productId"  : "#"+item.vendorProductId,
            "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={item.title}  /></Box>,
            "title"      : <Box className="productTitleBox" title={item.title}>{item.title}</Box>,
            "price"      : `₹${item.price.toFixed(2)}`,
            "sku"        : item.sku ? item.sku : '-',
            "quantity"   : item.quantity,
            "fulfilledQuantity"   : item.fulfillableQuantity,
            "quantityForFulfill" : (item.quantity - item.fulfillableQuantity),
            "total"               : `₹${(item.price * item.quantity).toFixed(2)}`,
          };
          
          unfulfilledRows.push(tempData);
      });

      var fulfillmentRowsList = [];
      var fulfillmentItems    = responseData.data.fulfillmentDetails;
      fulfillmentItems.map((item, index) => {

        var fulfilledRows = [];
        item.fulfilledItems.map((items, itemIndex) => {
          
        let productImage      = items.productImage ? items.productImage : productNoImage;

        var tempData = {
          "productId"  : "#"+items.vendorProductId,
          "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={items.title}  /></Box>,
          "title"      : <Box className="productTitleBox" title={items.title}>{items.title}</Box>,
          "price"      : `₹${items.price.toFixed(2)}`,
          "sku"        : items.sku ? items.sku : '-',
          "fulfilledQuantity" : items.fulfilledQuantity,
          "shipmentStatus" : item.shipmentStatus ?? "Manifested",
        };
        
        fulfilledRows.push(tempData);

        });

        fulfillmentRowsList.push(fulfilledRows);
    });

    if(operation === "details")
    {
      setOrderContext(dispatch, { ...orderContext, 
        unfulfilledTableData: { unfulfilledColumns, unfulfilledRows, unfulfilledProductsCount: unfulfilledProductsCount, totalOrderedProducts: responseData.data.totalOrderedProducts },
        fulfilledTableData: { fulfilledColumns, fulfillmentRowsList, fulfillmentItems },
        orderDetails: { orderStatus: responseData.data.orderStatus, financialStatus: responseData.data.financialStatus, allItemsFulfilled: allItemsFulfilled },
      }); 
    }
    else 
    {
      setOrderContext(dispatch, { ...orderContext, 
        unfulfilledTableData: { unfulfilledColumns, unfulfilledRows, unfulfilledProductsCount: unfulfilledProductsCount, totalOrderedProducts: responseData.data.totalOrderedProducts },
        fulfilledTableData: { fulfilledColumns, fulfillmentRowsList, fulfillmentItems },
        orderDetails: { ...orderContext.orderDetails, 
                        orderAcceptStatus: 'accepted',
                        orderStatus: (responseData.data.vendorOrderFulfilledStatus === 'unfulfilled') ? 'accepted' : responseData.data.vendorOrderFulfilledStatus
                      },
      }); 
    }
  };

  const confirmationModelLoad = () => {
    return (      
      <Dialog open={confirmationDialogOpen} onClose={handleConfirmationDialogClose}>
        <DialogTitle>{t("Confirm Order Accept")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("Are you sure you want to accept this order?")}            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmationDialogClose} color="primary" disableRipple>
            {t("close")}
          </Button>
          <Button onClick = { () => handleOrderAction('accept') } color="secondary" disableRipple>
            {t("Confirm Accept")}
          </Button>
        </DialogActions>
      </Dialog>
      );    
  }   


  const handleOrderAction = (action) => {    

  let orderRejectReasonNote = (orderRejectReason === 'Others') ? orderRejectNote : orderRejectReason;

  let requestPayLoad = {
    action  : action,
    orderID : orderID,
    orderRejectNote : orderRejectReasonNote,
  };

  (action === "accept") ? (handleConfirmationDialogClose(), setLoading(true)) : setIsOrderRejectLoading(true);

  axios({    
        url     : (action === "accept") ? baseUrl+"/order/order-accept" : baseUrl+"/order/order-reject",
        method  : "POST",
        data    : requestPayLoad,
        headers : {
          Authorization   : bearerToken,
          function        : Config.FUNCTION_KEY
        },      
      }).then(function (response) 
      {
          const responseData           = response.data;
          const responseDataStatusCode = response.data.status;
          const responseStatusCode     = response.status;
          
          if(responseStatusCode === 200)
          {
              (action === "accept") ? setLoading(false) : setIsOrderRejectLoading(false);

              if(responseDataStatusCode === 0)
              {
                toast.error(t(response.data.message));
                return;
              }
              else if(responseDataStatusCode === 1)
              {
                toast.success(t(response.data.message));
                
                if(
                    action === "accept" && 
                    responseData.data && 
                    responseData.data.autoFulfillmentProducts && 
                    responseData.data.autoFulfillmentProducts === 1
                  )
                handleOrderDetailsAPIResponse(responseData, "order-accept");
                else 
                {
                  setOrderContext(dispatch, { ...orderContext, 
                    orderDetails: { ...orderContext.orderDetails, 
                                    orderStatus: (action === 'accept') ? 'accepted' : 'rejected',
                                    financialStatus: ( action === "reject" && pageContent.financialStatus === 'paid' ) ? 'refunded' : ( action === "reject" && pageContent.financialStatus === 'pending' ) ? 'voided' : pageContent.financialStatus
                                  },
                  }); 
                }
                
                if(action === "reject")
                handleOrderRejectModelClose();
                               
                return;                 
              }
          }    
      }).catch(function (error) {
        (action === "accept") ? setLoading(false) : setIsOrderRejectLoading(false);
        handleErrors(error, t, navigate);
      });
  };

  const loadOrderDetails = () => {
    setIsLoading(true);
    axios({      
          url     : baseUrl+"/order/details/"+orderID,
          method  : "GET",
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {      
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status;
            const responseMessage        = responseData.message;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);
                if(responseDataStatusCode === 0)
                {
                    if(responseMessage)
                    toast.error(t(responseMessage));
           
                    const redirectTimeout = setTimeout(() => {          
                      clearTimeout(redirectTimeout);          
                      window.location.href = "/order/list";          
                    }, 3000);
                }
                else if(responseDataStatusCode === 1 && responseData && responseData.data)
                handleOrderDetailsAPIResponse(responseData, "details");
            }        

        }).catch(function (error) {
          handleErrors(error, t, navigate);
        });
  }
   
  const handleOrderFulfillments = () => {
    setOrderContext(dispatch, { ...orderContext, 
      fulfillmentModelOpen: true,
    });  
  }

  const orderRejectModelLoad = () => {

    return (
      
        <Dialog id="order-reject-dialog" open={orderRejectModelOpen} onClose={handleOrderRejectModelClose}
          sx={{
            '& .MuiDialog-paper': {
              maxWidth: '400px', 
            },
          }}
        >
          <DialogTitle onClose={handleOrderRejectModelClose}>
            {t("Order Reject")}  
          </DialogTitle>

          <DialogContent dividers sx={{width: '400px'}}>

            <Grid container spacing={1} my={2}>      

              <Grid item xs={12}>
                <FormControl sx={{ width: '100%', }}>
                  {renderOrderRejectReason}
                  <Icon style={{position: 'absolute', right: 5, top: 15}}>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>

              {orderRejectReason === 'Others' ? 
                <Grid item xs={12} my={2}>
                  <FormControl sx={{ width: '100%' }}>
                    <TextField 
                      label = {t('Order Reject Note')}
                      variant = "outlined" 
                      value = {orderRejectNote}                   
                      onChange={handleChangeOrderRejectNote}
                      fullWidth
                      inputProps={{
                        maxLength: 20, 
                      }}
                    />
                    <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                      {t("Maximum 20 characters supported")}
                    </FormHelperText>
                  </FormControl>                     
                </Grid>
              : null}

            </Grid>
            <Container sx={{paddingLeft: '0px !important'}}>
                <Box my={2}>
                  <Button                     
                    variant="contained" 
                    sx={{color : '#FFFFFF', height : 45 }} 
                    onClick={() => handleOrderAction('reject')}
                    disabled={isOrderRejectLoading}
                    disableRipple
                    >
                    {t("Submit")}
                  </Button>

                  <Button                     
                    variant="contained" 
                    sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                    onClick={handleOrderRejectModelClose}
                    disabled={isOrderRejectLoading}
                    disableRipple
                    >
                    {t("Cancel")}
                  </Button>
                </Box>
            </Container>
            {isOrderRejectLoading ?       
              <Container>   
                <CircularProgress size={30} sx={{color: '#1a90ff', margin: '0px auto'}}/>
              </Container>
            : <></>}
          </DialogContent>          
        </Dialog>      
      );    
  }   

  return (
    <DashboardLayout>
      {confirmationDialogOpen ? confirmationModelLoad() : <></>}

      {loading ?
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}><CircularProgress color="inherit" /></Backdrop>
        :
        null}

      {Object.keys(pageContent).length > 0 ?
        <>
        <DashboardNavbar pageTitle={t('Order')+' #'+pageContent.orderNumber} pageSubTitle={t('Here are details about order')}/>
        <MDBox my={3}>
          {openFulfillmentModel ? <FulfillmentAction orderID={orderID} orderNumber={'#'+pageContent.orderNumber} /> : <></>}
          <Grid container spacing={2} my={1}>
              {isLoading ?  
                <Grid item xs={12}>
                  <Box className='circularLoadingCommonOuter'>
                      <CircularProgress size={30} className='circularLoadingCommon' />
                  </Box>
                </Grid>
              : <></>}

              <Grid item xs={12}>
                <Card mb={2} variant="outlined">
                  <CardContent>
                    <Grid container spacing={0} mt={1}>
                      <Grid item sm={6} xs={12} my={2}>
                        <Typography variant="h6" color="text.secondary">
                          {t('Order details')}
                        </Typography>
                        <Typography sx={{ fontSize: 14 }} component="div">
                          {t('Here are the current status of the order')}
                        </Typography>
                      </Grid>
                      <Grid item sm={6} xs={12} my={2} className="orderActionButton">
                        <Box display="flex" flexDirection="row-reverse">
                          {(orderContext.orderDetails.orderStatus === 'open') ? 
                            <>
                                <Box>
                                  <Button                     
                                    variant="contained" 
                                    sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                                    disableRipple
                                    onClick={() => handleConfirmationDialogOpen() }>
                                    {t("Order Accept")}                    
                                  </Button>
                                  <Button                     
                                    variant="contained" 
                                    sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                                    disableRipple
                                    onClick={() => handleOrderRejectSubmit()}>
                                    {t("Order Reject")}                    
                                  </Button>
                                </Box>                                                         
                            </> 
                          : <></>}
                            
                          {(orderContext.orderDetails.orderStatus != 'fulfilled' && orderContext.orderDetails.orderStatus != 'open' && orderContext.orderDetails.orderStatus != 'rejected') ?
                            <Button                     
                              variant="contained" 
                              sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                              disableRipple
                              onClick={() => handleOrderFulfillments()}>
                              {t("Order Fullfillments")}                    
                            </Button>
                          : <></>}    
                        </Box>                        
                      </Grid>
                    </Grid>

                    {orderRejectModelOpen ? orderRejectModelLoad() : <></>}

                    <OrderSummary 
                                  orderID = {orderID} 
                                  pageContent = {pageContent} 
                                  orderAcceptStatus = {orderContext.orderDetails.orderAcceptStatus}
                                  orderStatus = {orderContext.orderDetails.orderStatus}
                                  financialStatus = {orderContext.orderDetails.financialStatus}
                                />             

                  </CardContent>
                </Card>
              </Grid>

              <UnfulfillmentList orderID = {orderID} orderStatus = {orderContext.orderDetails.orderStatus} />     

              <FulfillmentList orderID={orderID} setLoading={setLoading} />

              <AddressDetails pageContent={pageContent}/> 

              <CalculationDetails pageContent={pageContent} /> 

          </Grid>
        </MDBox>
        </>         
      : <></>}        
      </DashboardLayout>
  );
}
export default OrderDetails;
